import EventListingSection from "../../components/Events/EventListingSection";
import Page from "../../finwell/pages/Page";
import SessionRescheduleComp from "../../components/RescheduleSessionComp/SessionRescheduleComp";
import LeaderBoardComp from "../../components/leaderboardComp/LeaderBoardComp";
import "./SessionReschedulePage.scss";

const SessionReschedulePage = () => {

  return (
    <Page>
      <section className="leaderboard-page">
        <div className="container mt-4">
        <SessionRescheduleComp />
        </div>
      </section>
    </Page>

  )


}

export default SessionReschedulePage;